<nav [class.dropdown-active]="dropdownActivated" *ngIf="user && navLinks" (mouseleave)="closeDropdowns()">
  <div class="nav-list">
    <div class="nav-link-container" *ngFor="let link of navLinks; let i = index">
      <div class="nav-link-row" *ngIf="canAccessLink(link)">
        <a
          *ngIf="!link.dropdown && !link.dynamic"
          class="nav-link"
          (click)="closeDropdowns()"
          [routerLink]="link.linkAction"
        >
          <i *ngIf="link.linkIcon" class="{{ link.linkIcon }}"></i>
          {{ link.linkName }}
        </a>
        <button
          *ngIf="link.dropdown"
          type="button"
          class="nav-link nav-trigger"
          (mouseenter)="openDropdown(i)"
          (focus)="openDropdown(i)"
          (click)="toggleDropdown(i, $event)"
        >
          <i *ngIf="link.linkIcon" class="{{ link.linkIcon }}"></i>
          <span>{{ link.linkName }}</span>
          <i class="nav-caret"></i>
        </button>
        <button
          *ngIf="!link.dropdown && link.dynamic"
          type="button"
          class="nav-link nav-action"
          [class.disabled]="!callQueuePage"
          (click)="dynamicLink(link)"
        >
          <i *ngIf="link.linkIcon" class="{{ link.linkIcon }}"></i>
          {{ link.linkName }}
        </button>
      </div>
      <div *ngIf="dropdowns[i] && link.dropdown">
        <div
          [class.active]="dropdowns[i].activated"
          class="dropdown"
          (mouseenter)="openDropdown(i)"
          (mouseleave)="closeDropdown(i)"
        >
          <ul *ngIf="canAccessLink(link)">
            <li *ngFor="let childLink of link.dropdown.links" [hidden]="!canAccessLink(childLink)">
              <a
                *ngIf="!childLink.dynamic && canAccessLink(childLink)"
                (click)="closeDropdowns()"
                [routerLink]="childLink.linkAction"
              >
                {{ childLink.linkName }}</a
              >
              <button
                *ngIf="childLink.dynamic && canAccessLink(childLink)"
                type="button"
                class="dropdown-action"
                (click)="dynamicLink(childLink)"
              >
                {{ childLink.linkName }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</nav>
